import { FileText } from 'lucide-react'

interface VisitSummaryCardProps {
  summary: string | null
}

export default function VisitSummaryCard({ summary }: VisitSummaryCardProps) {
  return (
    <div className="rounded-lg border bg-white p-4 space-y-2">
      <div className="flex items-center gap-2">
        <FileText className="h-4 w-4 text-slate-400" />
        <h3 className="text-sm font-semibold text-slate-900">Visit Summary</h3>
      </div>
      {summary ? (
        <p className="text-sm text-slate-700 leading-relaxed">{summary}</p>
      ) : (
        <p className="text-sm text-slate-400 italic">
          Summary will appear once a recording is processed.
        </p>
      )}
    </div>
  )
}
